import type { GlobalRegion } from '@/types/geo'

type CountryCodeToRegionMap = Record<string, GlobalRegion>

const countryCodeToRegionMap: CountryCodeToRegionMap = {
  US: 'US/CANADA',
  FR: 'EMEA',
  DE: 'EMEA',
  IT: 'EMEA',
  GB: 'EMEA',
  PL: 'EMEA',
  AT: 'EMEA',
  BR: 'LATAM',
  AU: 'APAC',
  IN: 'APAC',
  CA: 'US/CANADA',
  ES: 'EMEA',
  RU: 'EMEA',
  JP: 'APAC',
  CN: 'APAC',
  KR: 'APAC',
  CH: 'EMEA',
  MX: 'LATAM',
  CZ: 'EMEA',
  NL: 'EMEA',
  BE: 'EMEA',
  RO: 'EMEA',
  SE: 'EMEA',
  PT: 'EMEA',
  HU: 'EMEA',
  PH: 'APAC',
  NO: 'EMEA',
  AR: 'LATAM',
  UA: 'EMEA',
  ID: 'APAC',
  CO: 'LATAM',
  TR: 'EMEA',
  IE: 'EMEA',
  SK: 'EMEA',
  FI: 'EMEA',
  GR: 'EMEA',
  TH: 'APAC',
  DK: 'EMEA',
  ZA: 'EMEA',
  NZ: 'APAC',
  HR: 'EMEA',
  VN: 'APAC',
  SI: 'EMEA',
  KZ: 'APAC',
  RS: 'EMEA',
  IL: 'EMEA',
  BG: 'EMEA',
  VE: 'LATAM',
  IR: 'EMEA',
  TW: 'APAC',
  PK: 'APAC',
  EC: 'LATAM',
  DZ: 'EMEA',
  MD: 'EMEA',
  HK: 'APAC',
  PE: 'LATAM',
  MA: 'EMEA',
  MY: 'APAC',
  LT: 'EMEA',
  DO: 'LATAM',
  CL: 'LATAM',
  EE: 'EMEA',
  BA: 'EMEA',
  LU: 'EMEA',
  CR: 'LATAM',
  BD: 'APAC',
  LV: 'EMEA',
  BY: 'EMEA',
  TN: 'EMEA',
  NG: 'EMEA',
  GT: 'LATAM',
  LK: 'APAC',
  EG: 'EMEA',
  PR: 'LATAM',
  HN: 'LATAM',
  PA: 'LATAM',
  UY: 'LATAM',
  TZ: 'EMEA',
  SV: 'LATAM',
  KE: 'EMEA',
  SA: 'EMEA',
  MU: 'APAC',
  AM: 'EMEA',
  MK: 'EMEA',
  PY: 'LATAM',
  CU: 'LATAM',
  NP: 'APAC',
  NI: 'LATAM',
  LB: 'EMEA',
  AE: 'EMEA',
  CY: 'EMEA',
  SY: 'EMEA',
  PS: 'EMEA',
  IQ: 'EMEA',
  BO: 'LATAM',
  JM: 'US/CANADA',
  GE: 'EMEA',
  MT: 'EMEA',
  BB: 'US/CANADA',
  TT: 'US/CANADA',
  AZ: 'EMEA',
  IS: 'EMEA',
  UG: 'EMEA',
  AL: 'EMEA',
  KW: 'EMEA',
  CI: 'EMEA',
  JO: 'EMEA',
  UZ: 'APAC',
  SN: 'EMEA',
  KH: 'APAC',
  SG: 'APAC',
  BH: 'EMEA',
  MM: 'APAC',
  GH: 'EMEA',
  HT: 'US/CANADA',
  OM: 'EMEA',
  AO: 'EMEA',
  ZM: 'EMEA',
  ME: 'EMEA',
  MN: 'APAC',
  FO: 'EMEA',
  SD: 'EMEA',
  RE: 'EMEA',
  NA: 'EMEA',
  CM: 'EMEA',
  KG: 'EMEA',
  YE: 'EMEA',
  BS: 'US/CANADA',
  LY: 'EMEA',
  PG: 'APAC',
  MG: 'EMEA',
  GP: 'EMEA',
  MQ: 'EMEA',
  ZW: 'EMEA',
  PF: 'EMEA',
  ET: 'EMEA',
  CD: 'EMEA',
  MZ: 'EMEA',
  LA: 'APAC',
  BW: 'EMEA',
  QA: 'EMEA',
  VI: 'US/CANADA',
  NC: 'APAC',
  GU: 'APAC',
  TJ: 'APAC',
  AF: 'APAC',
  RW: 'EMEA',
  BZ: 'LATAM',
  SR: 'LATAM',
  SC: 'APAC',
  KN: 'APAC',
  CV: 'EMEA',
  CF: 'EMEA',
  BJ: 'EMEA',
  VC: 'LATAM',
  BF: 'EMEA',
  MV: 'APAC',
  GL: 'EMEA',
  TD: 'EMEA',
  ML: 'EMEA',
  GY: 'LATAM',
  AD: 'EMEA',
  SO: 'EMEA',
  LR: 'EMEA',
  GN: 'EMEA',
  GF: 'LATAM',
  AG: 'LATAM',
  BT: 'APAC',
  LC: 'LATAM',
  YT: 'LATAM',
  TM: 'APAC',
  NE: 'EMEA',
  XK: 'EMEA',
  MW: 'EMEA',
  IM: 'EMEA',
  GD: 'LATAM',
  PW: 'APAC',
  LI: 'EMEA',
  FM: 'APAC',
  BI: 'EMEA',
  TL: 'APAC',
  SM: 'EMEA',
  GA: 'EMEA',
  FJ: 'APAC',
  MR: 'EMEA',
  LS: 'EMEA',
  WS: 'APAC',
  BM: 'US/CANADA',
  JE: 'EMEA',
  CW: 'LATAM',
  AX: 'EMEA',
  GM: 'EMEA',
  GG: 'EMEA',
  CK: 'APAC',
  CG: 'EMEA',
  TG: 'EMEA',
  SZ: 'EMEA',
  SB: 'APAC',
  BN: 'APAC',
  NR: 'APAC',
  SL: 'EMEA',
  DM: 'LATAM',
  TV: 'APAC',
  KY: 'US/CANADA',
  KM: 'EMEA',
  GQ: 'EMEA',
  AW: 'LATAM',
  AS: 'APAC',
  MO: 'APAC',
  GW: 'EMEA',
  DJ: 'EMEA',
  BQ: 'EMEA',
  SX: 'EMEA',
  MP: 'EMEA',
  MC: 'EMEA',
  KI: 'APAC',
  WF: 'APAC',
  VG: 'LATAM',
  TO: 'APAC',
  TC: 'LATAM',
  ST: 'EMEA',
  ER: 'EMEA',
  VU: 'APAC',
  MS: 'EMEA',
  SH: 'EMEA',
  AI: 'LATAM',
  TK: 'EMEA',
  SS: 'EMEA',
  SJ: 'EMEA',
  MH: 'APAC',
  MF: 'LATAM',
  KP: 'APAC',
  BL: 'EMEA',
  PM: 'EMEA',
  NF: 'EMEA',
  IO: 'EMEA',
  EH: 'EMEA',
  AQ: 'US/CANADA',
  ZZ: 'EMEA',
  VA: 'EMEA',
  UM: 'APAC',
  GI: 'EMEA',
  CC: 'APAC',
  TF: 'APAC',
  PN: 'EMEA',
  NU: 'EMEA',
  GS: 'EMEA',
  FK: 'EMEA',
  CX: 'LATAM',
  BV: 'EMEA',
  HM: 'EMEA',
}

export function getGlobalRegion(countryCode?: string | null): GlobalRegion | undefined {
  if (!countryCode) return undefined
  return countryCodeToRegionMap[countryCode.toUpperCase()]
}

export function getCountryNameFromCode(countryCode?: string | null): string | undefined {
  if (!countryCode || typeof Intl === 'undefined' || typeof Intl.DisplayNames === 'undefined') {
    return undefined
  }

  try {
    const displayNames = new Intl.DisplayNames(['en'], { type: 'region' })
    return displayNames.of(countryCode.toUpperCase()) ?? undefined
  } catch {
    return undefined
  }
}
